import React from 'react';

import AlbumSlideshowOnboarding from './AlbumSlideshowOnboarding';
import withModal from '../modal/withModal';

const AlbumSlideshowOnboardingModal = ({ actionProps, ...props }) => {
  return <AlbumSlideshowOnboarding {...props} {...actionProps} />;
};

export const ALBUM_SLIDESHOW_ONBOARDING_MODAL =
  'modal/ALBUM_SLIDESHOW_ONBOARDING_MODAL';

export default withModal(AlbumSlideshowOnboardingModal, {
  name: ALBUM_SLIDESHOW_ONBOARDING_MODAL,
  size: 'sm',
  type: 'full',
  overlayClassName: 'album-slideshow-onboarding-modal',
});
